import { Menu } from '@/entity/entity'

export const StorageAccess = {
  clear () : void {
    window.localStorage.clear()
  },
  getMenus () : Menu[] {
    const stored = window.localStorage.getItem('menus')
    return stored === null ? [] : JSON.parse(stored)
  },
  setMenus (menus: Menu[]) : void {
    window.localStorage.setItem('menus', JSON.stringify(menus))
  }
}
